import React from 'react';
import { useState, useEffect, Fragment } from "react";
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
// import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import VendorRequestReminderDialog from '../VendorRequestReminder';
// import { format } from "date-fns";
  


// let id = 0;
// function createData(date, by, reminderDate, notes, status) {
//   id += 1;
//   return { id, date, by, reminderDate, notes, status };
// }

// const rows = [
//   // comment
//   createData('2022-11-31', 'kpeak', '2023-01-04','Notes added here','In progress'),
//   createData('2022-12-14', 'kpeak', '2023-01-04','Different Note','Opened'),
//   createData('2022-12-31', 'kpeak', '2023-01-07','A third request','Closed'),
  
// ];

const addVendorRequest = (row) => {
    debugger;
  alert('Reminder Sent');


};
export const VendorRequestHistoryCard = React.memo(function VendorRequestHistoryCard(data) {
  //const classes = useStyles();
  //console.log(data.rows);
  //const [reqestReminder, setreqestReminder] = useState(false);
  //const [vendorRequestReminderOpen, setVendorRequestReminderOpen] = React.useState(false);
 
  var rows = data.rows;
  return (
    <Card className='requestTable'
    >
      <CardHeader
        titleTypographyProps={{variant:'h6' }}
        title={'Request History'}
        //   sx = {{m:0,p:0, background :'#1976d21a'}}
      />
      {/* <CardContent > */}
        <Table
        >
          <TableHead >
            <TableRow>
              <TableCell align="left">Request Date</TableCell>
              <TableCell align="left">Status</TableCell>
              <TableCell align="left">By</TableCell>
              <TableCell align="left">Reminder</TableCell>
              <TableCell align="left">Notes</TableCell>
              <TableCell align="left">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => ( 
              <TableRow key={row.requestId}>
                <TableCell component="th" scope="row">
                  {row.requestedOn}
                </TableCell>
                {(row.status===2) &&
                    <TableCell align="left"><Box sx={{ color: 'red' }} >Closed</Box></TableCell>
                }
                {(row.status===0) &&
                    <TableCell align="left"><Box sx={{ color: 'green' }} >Opened</Box></TableCell>
                }
                   {(row.status===1) &&
                    <TableCell align="left"><Box sx={{ color: 'orange' }} >In Progress</Box></TableCell>
                }
                <TableCell align="left">{row.requestedBy}</TableCell>
              
                <TableCell align="left">
                {(row.reminderSentOn) &&
                     (row.reminderSentOn)
                }
                </TableCell>
                <TableCell align="left">{row.notes}</TableCell>
                <TableCell align="left">
                {/* {(row.status===0 || row.status===1 ) &&
                  // <Button color="primary" variant="outlined" onClick={ShowReminderDialog()}>Reminder</Button>
                  <Button variant="outlined" onClick={() => addVendorRequest(row)}>Reminder</Button>
                  } */}
                  </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      {/* </CardContent> */}
      <VendorRequestReminderDialog
          reminder = {true}
          // vendorId={vendorId}
          // vendorRequestOpen={vendorRequestOpen}
          // setVendorRequestOpen={setVendorRequestOpen}
          // onClose={handleRequestCancel}
          // accessToken={vendorData.accessToken}
          // showSuccess={showRequestSuccess}
          // showError={showRequestError}
          // masterPiaExists={masterPiaExists}
        // vendorId = {vendorId}
        ></VendorRequestReminderDialog>
    </Card>
  );
});

export default VendorRequestHistoryCard